import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SnackbarStateUI } from 'src/app/interfaces/snackbar-state.interface';
import { SnackbarMessageKey } from 'src/app/utils/enums';
import { SnackbarTexts } from 'src/app/utils/text-content';
import { pluralizeAttempts } from 'src/app/utils/utils';

@Injectable({
	providedIn: 'root',
})
export class SnackbarService {
	private snackbarStateSubject = new BehaviorSubject<SnackbarStateUI | null>(null);
	readonly snackbarState$ = this.snackbarStateSubject.asObservable();

	private queue: (() => void)[] = [];
	private isProcessing = false;

	show(key: SnackbarMessageKey, attempts: string = ''): void {
		this.queue.push(() => this.emitSnackbar(key, attempts));
		this.processQueue();
	}

	private emitSnackbar(key: SnackbarMessageKey, attempts: string): void {
		this.snackbarStateSubject.next(null);

		setTimeout(() => {
			let state = { ...SnackbarTexts[key] };

			if (attempts) {
				state.message = state.message.replace('{{attemptMsg}}', pluralizeAttempts(attempts));
			}

			this.snackbarStateSubject.next(state);

			this.isProcessing = false;
			this.processQueue();
		}, 0);
	}

	private processQueue() {
		if (this.isProcessing || this.queue.length === 0) return;

		this.isProcessing = true;
		this.queue.shift()?.();
	}
}
